import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { AuthMapService } from 'src/app/services/auth-map.service';
import { GoogleMapService } from 'src/app/services/google-map.service';
import { OpenlayerMapService } from 'src/app/services/openlayer-map.service';
import { Platform } from '@ionic/angular';
import { app, storageVariable ,languageInitializer} from 'src/environments/environment';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-vts-nearby',
  templateUrl: './vts-nearby.component.html',
  styleUrls: ['./vts-nearby.component.scss'],
})

export class VtsNearbyComponent implements OnInit {
  map;
  range = 5;
  vehicleIcon;
  myPlatform;
  entryPoint:any;
  @Input() gridLiveChange;
  typeSelector = [{ id: 5, name: 5 }, { id: 10, name: 10 }, { id: 20, name: 20 }, { id: 40, name: 40 }, { id: 100, name: 100 }, { id: 250, name: 250 }];
  selectedVin = JSON.parse(localStorage.getItem('selectedVin'));
  dashBoardData = storageVariable.dashboardData;
  liveDatas = this.dashBoardData.liveDatas;
  @ViewChild('mapElement', { static: false }) mapElement;
  nearbyVehDetArr = [];
  directory: string = languageInitializer.directory;
  layerModal =false;
  statusIcon = {
    'Running': 'assets/vtsicon/BIKE/Running.svg',
    'Idle': 'assets/vtsicon/BIKE/idle.svg',
  }
  color = {
    'Idle': '#1f5baa',
    'Running': '#1eb15d',
    'Stop': '#FF0000',
    'Yet_to_transmit': '#7d410f',
    'No Transmission': '#000000',
    'Online': '#00E1BC',
    'Overspeed': '#f28918',
    'DoorOpen': '#FF851B',
    'HighTemp': '#FF0000',
    "PowerFail": '#412525',
    'Geofence': '#1f5baa',
    'Good': '#1eb15d',
    'Towed': '#ec268f',
    'StandBy': '#f4d642',
    "Working": "#1eb15d",
    "Out_Of_Zone": "#FF0000",
    "OnLine": "#00008b",
    "GSMLost": "#c200b8",
    "BatteryDrain": "#00aef3",
    "PowerCut": "#ff0000",
    "Movement": "#1eb15d",
    "LowBattery": "#fba300"

  }

  constructor(
    public mapService: AuthMapService,
    public platform: Platform,
    public commonService: CommonService
  ) {
    // if (localStorage.map === 'GoogleMap') {
    //   this.mapService = new GoogleMapService();
    // } else {
    this.mapService = new OpenlayerMapService();
    // }

  }

  ngOnInit() {
    this.entryPoint=localStorage.getItem("entryPoint")
    this.myPlatform = this.platform.platforms()[0];
    if (this.myPlatform == 'tablet') {
      this.myPlatform = 'desktop';
    }
    setTimeout(() => {
      this.createMap();
    }, 2000);

    this.commonService.updateLanguageDir
    .subscribe(res => {
      this.directory = res == "" ? this.directory : res
    })
  }

  createMap() {
    if (localStorage.map === 'GoogleMap') {
      this.map.updateSize();
      this.map = this.mapService.loadMap(this.mapElement.nativeElement, { lat: -25.344, lng: 131.036 }, false, false);
    } else {
      this.map = this.mapService.loadMap(this.mapElement.nativeElement, { lat: -25.344, lng: 131.036 }, false, false);
    }
    this.mapService.setCenter(this.map, { lat: 17.786351, lng: 78.090820 });
    const latLng = { lat: this.selectedVin.latitude, lng: this.selectedVin.longitude };

    this.mapService.addMarker(this.map, latLng, 'nearBy', 'assets/vtstrackhisIcon/Idle.png');

    this.nearbyVehDetArr = [];
    const liveDataLength = Object.keys(this.liveDatas).length;
    this.liveDatas = Object.values(this.liveDatas);
    for (let i = 0; i < liveDataLength; i++) {
      const radlat1 = Math.PI * this.selectedVin.latitude / 180;
      const radlat2 = Math.PI * this.liveDatas[i].latitude / 180;
      const theta = this.selectedVin.longitude - this.liveDatas[i].longitude;
      const radtheta = Math.PI * theta / 180;
      const latlng = { lat: this.liveDatas[i].latitude, lng: this.liveDatas[i].longitude };
      let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1)
        * Math.cos(radlat2) * Math.cos(radtheta);
      dist = Math.acos(dist);
      dist = dist * 180 / Math.PI;
      dist = dist * 60 * 1.1515;
      dist = dist * 1.609344;
      dist = Math.ceil(dist);

      switch (this.liveDatas[i].status) {
        case 'Stop':
          this.vehicleIcon = 'assets/vtsicon/BIKE/Stop.svg';
          break;
        case 'Idle':
          this.vehicleIcon = 'assets/vtsicon/BIKE/Idle.svg';
          break;
        case 'Running':
          this.vehicleIcon = 'assets/vtsicon/BIKE/Running.svg';
          break;
        case 'Yet_to_transmit':
          this.vehicleIcon = 'assets/vtsicon/BIKE/Yet_to_transmit.svg';
          break;
        case 'No Transmission':
          this.vehicleIcon = 'assets/vtsicon/BIKE/No Transmission.svg';
          break;
      }

      this.nearbyVehDetArr.push({
        vin: this.liveDatas[i].vin,
        plateno: this.liveDatas[i].plateNo,
        distance: dist,
        status: this.liveDatas[i].status,
        latLng: latlng,
        icon: this.vehicleIcon,
        assert: this.liveDatas[i].icon
      });
      //this.mapService.addMarker(this.map, this.nearbyVehDetArr[i].latLng , 'geofence' , this.nearbyVehDetArr[i].icon);
    }
  }

  ngOnChanges() {
    if (this.gridLiveChange) {
      this.selectedVin = this.gridLiveChange;
      this.mapService.clearLayers(this.map, [1, 2]);
      const latLng = { lat: this.gridLiveChange.latitude, lng: this.gridLiveChange.longitude };
      this.mapService.addMarker(this.map, latLng, 'nearBy', 'assets/vtstrackhisIcon/Idle.png');
      const liveDataLength = Object.keys(this.liveDatas).length;
      this.liveDatas = Object.values(this.liveDatas);
      this.nearbyVehDetArr = [];
      for (let i = 0; i < liveDataLength; i++) {
        const radlat1 = Math.PI * this.selectedVin.latitude / 180;
        const radlat2 = Math.PI * this.liveDatas[i].latitude / 180;
        const theta = this.selectedVin.longitude - this.liveDatas[i].longitude;
        const radtheta = Math.PI * theta / 180;
        const latlng = { lat: this.liveDatas[i].latitude, lng: this.liveDatas[i].longitude };
        let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1)
          * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;
        dist = dist * 1.609344;
        dist = Math.ceil(dist);

        switch (this.liveDatas[i].status) {
          case 'Stop':
            this.vehicleIcon = 'assets/vtsicon/BIKE/Stop.svg';
            break;
          case 'Idle':
            this.vehicleIcon = 'assets/vtsicon/BIKE/Idle.svg';
            break;
          case 'Running':
            this.vehicleIcon = 'assets/vtsicon/BIKE/Running.svg';
            break;
          case 'Yet_to_transmit':
            this.vehicleIcon = 'assets/vtsicon/BIKE/Yet_to_transmit.svg';
            break;
          case 'No Transmission':
            this.vehicleIcon = 'assets/vtsicon/BIKE/No Transmission.svg';
            break;
        }

        this.nearbyVehDetArr.push({
          vin: this.liveDatas[i].vin,
          plateno: this.liveDatas[i].plateNo,
          distance: dist,
          status: this.liveDatas[i].status,
          latLng: latlng,
          icon: this.vehicleIcon,
          assert: this.liveDatas[i].icon
        });
        //this.mapService.addMarker(this.map, this.nearbyVehDetArr[i].latLng , 'geofence' , this.nearbyVehDetArr[i].icon);
      }
      console.log(this.nearbyVehDetArr);
    }
  }

  getArabicLetters(letter) {

    return this.commonService.numberToArabic(letter)
  }

  switchMap() {
    this.layerModal = !this.layerModal
  this.map.getLayers().item(3).setVisible(this.layerModal);
    this.map.getLayers().item(0).setVisible(!this.layerModal);
  }

  showNearByVehicle() {
    this.mapService.clearLayers(this.map, [1, 2]);
    const latLng = { lat: this.selectedVin.latitude, lng: this.selectedVin.longitude };
    this.mapService.addMarker(this.map, latLng, 'nearBy', 'assets/vtstrackhisIcon/Idle.png');
    const near = [];
    for (let i = 0; i < this.nearbyVehDetArr.length; i++) {
      if (this.range >= this.nearbyVehDetArr[i].distance) {
        near.push(this.nearbyVehDetArr[i]);
        if (this.nearbyVehDetArr[i].assert == "TRUCK" || this.nearbyVehDetArr[i].assert == "REFRIGERATOR" || this.nearbyVehDetArr[i].assert == "STREET SWEEPER" || this.nearbyVehDetArr[i].assert == "HOOK LIFT" || this.nearbyVehDetArr[i].assert == "BATTERY" || this.nearbyVehDetArr[i].assert == "TANKER" || this.nearbyVehDetArr[i].assert == "CAR" || this.nearbyVehDetArr[i].assert == "BUS" || this.nearbyVehDetArr[i].assert == "AUTO" || this.nearbyVehDetArr[i].assert == "BIKE"
            || this.nearbyVehDetArr[i].assert == "DOUBLE CABIN") {
          var viewbox = "0 0 3571.4 1948.1";  
      var x="350";var y="-50";var x1="575";var y1="780";  
        }
        else {
          var viewbox = "-700 -600 3571.4 1948.1";
      var x="-175";y="-600";var x1="-150";var y1="220";
        }
        let svg1 = `
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="35.714mm" height="25.481mm" version="1.1" style="black;shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="${viewbox}" xmlns:xlink="http://www.w3.org/1999/xlink">
  <path fill="${this.commonService.color[this.nearbyVehDetArr[i].status]}" d="${this.commonService.vehicleModelmap[this.nearbyVehDetArr[i].assert]}"/>
  <rect x="${x}" y="${y}" width="${this.nearbyVehDetArr[i].plateno.length * 220}" height="35%" fill="${this.commonService.color[this.nearbyVehDetArr[i].status]}" />
  <g transform="matrix(0.999986 0 0 0.999986 9.42214 -382.593)">
    <text style="font-weight:bold;font-size:300px;  text-align: center;font-family:'Arial'" fill="white" x="${x1}" y="${y1}">${this.nearbyVehDetArr[i].plateno}</text>
  </g>
</svg>`;
        // let svg1 = '   <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="24.714mm" height="15.481mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"  ' +
        //   '   viewBox="0 0 2471.4 1548.1"  ' +
        //   '    xmlns:xlink="http://www.w3.org/1999/xlink">  ' +
        //   '     <path fill="' + this.commonService.color[this.nearbyVehDetArr[i].status] + '"  d="' + this.commonService.vehicleModelmap[this.nearbyVehDetArr[i].assert] + '"/>  ' +
        //   '     <path fill="' + this.commonService.color[this.nearbyVehDetArr[i].status] + '"  d="M47.78 0.01l2375.87 0c26.38,0.02 47.76,27.23 47.76,60.82l0 493.09c0,33.57 -21.38,60.78 -47.76,60.78l-2375.87 0.02c-26.39,-0.02 -47.76,-27.23 -47.76,-60.82l-0.03 -493.09c0.03,-33.57 21.4,-60.78 47.79,-60.78l0 -0.02z"/>  ' +
        //   '     <g transform="matrix(0.999986 0 0 0.999986 9.42214 -382.593)">  ' +
        //   '      <text style="font-weight:bold;font-size:300px;font-family:\'Arial\'" fill="white" x="50%" y="50%"  text-anchor="middle" >' + this.nearbyVehDetArr[i].plateno + '</text>  ' +
        //   '     </g>  ' +
        //   '   </svg>  '
        if (app.entryPoint == "WFT")
          svg1 = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" width="1in" height="1in" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 600 700">

        <path fill="${this.commonService.color[this.nearbyVehDetArr[i].status]}" d="M194.92 217.82c1.45,-0.48 2.76,-0.67 3.41,0.78l0.09 -30.69c-7.61,-1.43 -15.56,5.63 -18.05,9.18 -5.11,7.25 -4.16,13.81 -4.16,23.52 0,18.56 0.02,37.12 0,55.67 0,3.89 -0.65,9.38 1.12,12.53 1.53,2.74 4.73,5.36 9.46,4.71 9.22,-1.28 7.71,-11.78 7.7,-20.31 -0.01,-8.59 -0.97,-50.74 0.43,-55.39zm43.51 217.49l-11.76 11.76 -11.76 -11.76c-31.07,-5.55 -54.67,-32.72 -54.67,-65.39 0,-1.8 0.07,-3.57 0.21,-5.33 2.72,34.19 31.39,62.79 66.28,62.79 34.89,0 63.43,-28.59 66.15,-62.78 0.14,1.76 0.21,3.54 0.21,5.33 0,32.67 -23.59,59.84 -54.67,65.39zm38.7 -172.38c-0.19,-16.11 -0.02,-32.33 -0.02,-48.47 0.01,-10.87 -2.5,-19.58 -12.41,-24.43 -2.57,-1.26 -6.57,-2.72 -9.78,-2.12l0.01 30.7c0.95,-1.5 2.05,-1.26 3.5,-0.84 1.99,6.38 -0.67,64.22 0.81,69.31 2.36,8.15 13.2,8.72 16.93,1.44 1.65,-3.24 0.87,-9.39 0.96,-13.42l-0.03 -1.36 0.04 -8.91 -0.02 -1.91zm-75.9 11.6l0 9.64 -1.31 0.5c-1,0.3 -0.2,-0.19 -1.42,0.37 -0.46,10.93 -0.05,22.73 -0.05,33.76l0 68.39c0,7.82 -2.13,21.44 10.37,23.97 5.8,1.18 9.61,-1.18 12.39,-4.02 3.8,-3.89 3.49,-7.55 3.48,-13.83l0 -93.81c0,-2.5 -0.7,-6.44 1.98,-6.43 2.62,0 2,3.56 1.98,5.99l0.02 93.82c0,5.95 -0.44,10.18 3.26,14.04 7.85,8.18 18.5,4.22 21.82,-3.19 1.82,-4.08 1.15,-11.26 1.15,-16.11 0,-11.4 0,-22.8 0,-34.2 0,-22.4 0.77,-46.17 -0.05,-68.39l-2.73 -0.88 -0.03 -10.09 0.05 -86.38 -6.13 0 0.01 62.19 -15.12 -0.74c-0.29,-6.26 -0.04,-12.98 -0.04,-19.17 0,-11.46 7.16,-32.1 12.3,-42.09l-33.02 -0.2c3.5,13.05 10.23,29.82 10.23,42.55 0,6.34 0.25,13.22 -0.04,19.49l-12.85 0.15 -0.13 -62.15 -6.09 -0.06 -0.02 86.85zm19.63 -138.63c-2.69,2.15 -2.97,-2.43 -3.3,-4.39 -0.39,-2.33 -0.83,-5.77 -1.44,-7.68 -7.01,3.63 -11.76,10.41 -12.63,20.93 -1.79,0.91 -3.93,0.65 -4.18,3.52 -0.25,2.9 1.44,3.88 4.11,3.88l46.48 0.01c2.55,-0.01 4.11,-0.83 4.12,-3.47 0.02,-3.4 -2.24,-2.97 -4.22,-3.95 -0.89,-10.65 -5.65,-17.23 -12.62,-20.94 -1.53,4.83 -1.16,15.24 -4.71,12.08 -1.96,-1.93 1.53,-11.45 1.16,-14.82 -1.31,-2.5 -6.43,-1.91 -9.17,-1.91 -10.63,0 0,13.17 -3.61,16.72zm26.56 20.99l-41.52 -0.14c-1.71,12.18 9.53,22.29 20.76,22.29 11.22,0 22.47,-10.18 20.76,-22.15z" x="20" style="&#10;    x: 20;&#10;"/>
         <rect fill="${this.commonService.color[this.nearbyVehDetArr[i].status]}" x="-19" y="12" width="900" height="110" style="&#10;    /* width: 709px; */&#10;"/>
         <text xmlns="http://www.w3.org/2000/svg" style="font-weight:bold;font-size: 51.44px;font-family:'Arial';" x="0" y="58.42" fill="white">${this.nearbyVehDetArr[i].plateno.split('@,@')[0]}</text>
    <text xmlns="http://www.w3.org/2000/svg" style="font-weight:bold;font-size: 51.44px;font-family:'Arial';" x="360" y="113" fill="white">${this.nearbyVehDetArr[i].plateno.split('@,@')[1]}</text>
     </svg>`;
        const src = 'data:image/svg+xml;charset=utf-8,'
          + encodeURIComponent(svg1);

        this.mapService.addMarker(this.map, this.nearbyVehDetArr[i].latLng, this.nearbyVehDetArr[i].vin, src);
      }
    }
    this.mapService.fitBounds(this.map, 1);
    //   for (let i = 0; i < near.length ; i++) {
    //   if (this.range >= near[i].distance) {

    //     this.mapService.fitBounds(this.map, 1);
    //   }
    // }
  }
}
